import React, {Component} from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import Datetime from 'react-datetime';
import {Alert, Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Media, Row,} from 'reactstrap';

import {closeAlert} from '../../../actions/commonsActions';
import {downloadTotalCsvStat} from '../../../actions/statsActions';
import {PAGINATION_DEFAULT_LIMIT, USER_ROLES,} from '../../../helpers/constants';
import Pagination from '../../Pagination/Pagination';
import {fetchCompanies} from '../../../actions/companyActions';
import {getColorsObject} from '../../../helpers/getRandomRgb';
import {I18n} from '../../../I18n/components/Promo/PromoSummaryStat';

import 'react-datetime/css/react-datetime.css';
import 'react-table/react-table.css';
import './promoSummaryStat.css';
import spinner from "../../../assets/images/spinner.gif";
import {fetchRedirectsStat} from "../../../actions/promoActions";
import {createCsv} from "../../../helpers/createCsv";

class PromoSummaryStat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD'),
            filter: '',
            retailerCompanyId: null,
            retailerCompanies: [],
            color: '',
            isCsvDownload: false,
            currentPage: 0,
            filters: [],
        };
    }

    componentDidMount() {
        (async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const dateFrom = urlParams.has('dateFrom') ? urlParams.get('dateFrom') : null;
            const dateTo = urlParams.has('dateTo') ? urlParams.get('dateTo') : null;

            if (dateFrom && dateTo) {
                await this.setState({
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                });
            }
            try {
                if (!this.props.companyId || !this.props.companies[0]) {
                    await this.props.fetchCompanies();
                }
                await this.props.fetchTraderStat({
                    traderCompanyId: this.props.companyId,
                    dateFrom: this.state.dateFrom,
                    dateTo: this.state.dateTo,
                    page: 0
                });
                this.setState({
                    color: getColorsObject(0.1),
                    retailerCompanies: this.getRetailerCompaniesSet()
                })
            } catch (error) {
                console.log(error);
            }
        })();
    }

    getRetailerCompaniesSet = () =>  {
        const companies = this.props.stat.redirectsStatisticItems.map(item =>  item.company);
        const retailCompanyIds = Array.from(new Set(companies.map(company =>  company.id)));
        return retailCompanyIds.map(id => companies.find(c => c.id === id))
    };

    onFilterClick = name => {
        return event => {
            const value  = event.target.value;
            this.setState(state => {
                const filteredElemIndex = state.filters.findIndex(item => item.name === name);
                let filters = [...state.filters];
                if (filteredElemIndex !== -1) {
                    if (value && value !== '') {
                        filters[filteredElemIndex].name = name;
                        filters[filteredElemIndex].value = value;
                    } else {
                        filters = filters.filter(elem => elem.name !== name);
                    }
                } else {
                    filters = [...state.filters, {name : name, value: value}]
                }
                return {
                    [`${name}`]: value,
                    filters: filters
                }
            }/*, () => {
                this.fetchPaginatedData(0);
            }*/)
        }
    };

    dateToTimeChange = moment => {
        this.setState({
            dateTo: moment.format('YYYY-MM-DD')
        })
    };

    dateFromTimeChange = moment => {
        this.setState({
            dateFrom: moment.format('YYYY-MM-DD')
        })
    };

    getFiltered = async () => {
        this.fetchPaginatedData(0);
    };

    fetchPaginatedData = currentPage => {
        this.props.fetchTraderStat( {
            traderCompanyId: this.props.companyId,
            filters: this.state.filters.length ? this.state.filters : false,
            dateFrom: this.state.dateFrom,
            dateTo: this.state.dateTo,
            page: currentPage
        }).then(() => {
            this.setState({
                currentPage,
                // sortState: this.state.sorting ? this.state.sorting : {
                //     id: 'name',
                //     desc: true
                // },
                color: getColorsObject(0.1)
            });
        });
    };

    setCurrentPage = async currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };


    clearFilters = () => {
        this.setState({
            filters: [],
            filter: '',
            retailerCompanyId: null,
            dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD'),
        }, async () => {
            this.fetchPaginatedData(0);
        })
    };

    downloadCsv = () => {
        const {dateTo, dateFrom, companyId} = this.state;
        this.setState({
            isCsvDownload: true
        }, async () => {
            const response = await this.props.downloadTotalCsvStat({dateTo, dateFrom, companyId});
            if (response) {
                createCsv(response);
            }
            this.setState({
                isCsvDownload: false
            })
        })
    };

    render() {
        const {loading, lang, stat, companies} = this.props;
        return (
            <div className='summary-stats promo-sum-stats'>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
                </Alert>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-border-right mr-2"></i>{I18n[lang].redirects}
                        </div>
                    </CardTitle>

                    <CardBody>
                        {
                            (() => {
                                const {loading} = this.props;
                                if (loading) {
                                    return <div className="loading">Loading...</div>;
                                } else {
                                    /*let companyLabels = [];
                                    let companyDataSets = [];
                                    let dataValue = [];
                                    if (stat && stat.items) {
                                        const companyChartPoints = totalStats.reports.chartPoints;
                                        //const color = getRandomRgb();
                                        const color = this.state.color;
                                        dataValue = companyChartPoints && companyChartPoints.length ?
                                            companyChartPoints.map(elem => elem.value) : [];
                                        companyDataSets = [{
                                            label: totalStats.reports.companyName,
                                            data: dataValue,
                                            //fill: false,
                                            borderWidth: 1,
                                            backgroundColor: color ? color.opacityColor : '',
                                            borderColor: color? color.mainColor : '',
                                            pointBorderColor: color? color.mainColor : '',
                                            pointBackgroundColor: color? color.mainColor : '',
                                        }];
                                        companyLabels = companyChartPoints && companyChartPoints.length ?
                                            companyChartPoints.map(elem => elem.label) : [];
                                    }*/
                                    const stats = stat && stat.redirectsStatisticItems ? stat.redirectsStatisticItems : [];
                                    let firstElementNumber = this.state.currentPage * PAGINATION_DEFAULT_LIMIT + 1;


                                    const filterByRetailerCompanies = this.state.retailerCompanies && this.state.retailerCompanies.length ? (
                                            <Input
                                                className="retail_company_selector userlist-card__input userlist-card__input-company"
                                                type="select"
                                                name="retailerCompanyId"
                                                id="retailerCompanyId"
                                                onChange={this.onFilterClick('retailerCompanyId')}
                                                value={this.state.retailerCompanyId}
                                            >
                                                <option value="">{I18n[this.props.lang].all}</option>
                                                {
                                                    this.state.retailerCompanies.map((item, i) => {
                                                        return (
                                                            <option value={item.id} key={i}>{item.name}</option>
                                                        )
                                                    })
                                                }
                                            </Input>
                                        ) : null;

                                    const tableData = stats.map(item => {
                                        return {
                                            count_id: firstElementNumber++,
                                            //id: item.id,
                                            appName: item.appName,
                                            offerTitle: item.offerTitle,
                                            company: item.company.name,
                                            salesPoint: item.salesPoint,
                                            user: item.user,
                                            device: item.device || "",
                                            dateTime: item.dateTime ? moment(item.dateTime).format('YYYY-MM-DD HH:mm') : 'none',
                                        };
                                    });
                                    let columns = [
                                        {
                                            Header: "#",
                                            accessor: "count_id",
                                            sortable: false,
                                            filterable: false,
                                            style: {
                                                textAlign: "left",
                                                fontSize: "0.7rem",
                                                textTransform: "lowercase"
                                            },
                                            maxWidth: 40
                                        },
                                        {
                                            Header: `${I18n[lang].app}`,
                                            accessor: "appName",
                                            sortable: false,
                                            filterable: false,
                                            style: {
                                                textAlign: "left"
                                            }
                                        },
                                        {
                                            Header: `${I18n[lang].offerTitle}`,
                                            accessor: "offerTitle",
                                            sortable: false,
                                            filterable: false,
                                            style: {
                                                textAlign: "center"
                                            }
                                        },
                                        {
                                            Header: `${I18n[lang].company}`,
                                            accessor: "company",
                                            sortable: false,
                                            filterable: false,
                                            style: {
                                                textAlign: "center"
                                            }
                                        },
                                        {
                                            Header: `${I18n[lang].salesPoint}`,
                                            accessor: "salesPoint",
                                            sortable: false,
                                            filterable: false,
                                            style: {
                                                textAlign: "center"
                                            },
                                        },
                                        {
                                            Header: `${I18n[lang].user}`,
                                            accessor: "user",
                                            sortable: false,
                                            filterable: false,
                                            style: {
                                                textAlign: "center"
                                            },
                                        },
                                        {
                                            Header: `${I18n[lang].device}`,
                                            accessor: "device",
                                            sortable: false,
                                            filterable: false,
                                            style: {
                                                textAlign: "center"
                                            },
                                        },
                                        {
                                            Header: `${I18n[lang].dateTime}`,
                                            accessor: "dateTime",
                                            sortable: false,
                                            filterable: false,
                                            style: {
                                                fontSize: "0.7rem",
                                                textAlign: "center"
                                            },
                                        }
                                    ]
                                    return (
                                        <div>
                                            {/*<Row className="stat-graf">*/}
                                            {/*    <Col lg="12">*/}
                                            {/*        <div className="campaign ct-charts">*/}
                                            {/*            <div className="chart-wrapper"*/}
                                            {/*                 style={{ width: '100%', margin: '0 auto', height: 350 }}>*/}
                                            {/*                <Line*/}
                                            {/*                    data={{*/}
                                            {/*                        datasets: companyDataSets,*/}
                                            {/*                        labels: companyLabels*/}
                                            {/*                    }}*/}
                                            {/*                    datasetKeyProvider={() => `${nanoid()}`}*/}
                                            {/*                    options={{*/}
                                            {/*                        maintainAspectRatio: false,*/}
                                            {/*                        legend: {*/}
                                            {/*                            display: false,*/}
                                            {/*                            labels: { fontFamily: "Nunito Sans" }*/}
                                            {/*                        },*/}
                                            {/*                        scales: {*/}
                                            {/*                            yAxes: [{*/}
                                            {/*                                stacked: false,*/}
                                            {/*                                gridLines: { display: false },*/}
                                            {/*                                ticks: {*/}
                                            {/*                                    fontFamily: "Nunito Sans",*/}
                                            {/*                                    beginAtZero:true,*/}
                                            {/*                                    min: 0,*/}
                                            {/*                                    stepSize: (Math.max(dataValue) / 2).toFixed()*/}
                                            {/*                                }*/}
                                            {/*                            }],*/}
                                            {/*                            xAxes: [{*/}
                                            {/*                                stacked: false,*/}
                                            {/*                                gridLines: { display: false },*/}
                                            {/*                                ticks: {*/}
                                            {/*                                    fontFamily: "Nunito Sans",*/}
                                            {/*                                    stepSize: 1,*/}
                                            {/*                                    beginAtZero:true*/}
                                            {/*                                }*/}
                                            {/*                            }]*/}
                                            {/*                        }*/}
                                            {/*                    }}*/}
                                            {/*                />*/}
                                            {/*            </div>*/}
                                            {/*        </div>*/}
                                            {/*    </Col>*/}
                                            {/*</Row>*/}
                                            <Row>
                                                <Col lg="12">
                                                    <FormGroup>
                                                        <Input
                                                            className="summary-search-filter"
                                                            type="text"
                                                            name="search"
                                                            id="search"
                                                            value={this.state.filter}
                                                            onChange={this.onFilterClick('filter')}
                                                            placeholder={I18n[lang].filter}
                                                        />
                                                        {filterByRetailerCompanies}
                                                        <Datetime
                                                            className="summary-data-filter"
                                                            locale="en-gb"
                                                            timeFormat={false}
                                                            closeOnSelect={true}
                                                            inputProps={{
                                                                placeholder: `${I18n[lang].dateFrom}`,
                                                                readOnly: true
                                                            }}
                                                            onChange={this.dateFromTimeChange}
                                                            value={this.state.dateFrom ? moment(this.state.dateFrom).format('DD.MM.YYYY') : ''}
                                                        />
                                                        <Datetime
                                                            className="summary-data-filter date-to"
                                                            locale="en-gb"
                                                            timeFormat={false}
                                                            closeOnSelect={true}
                                                            inputProps={{
                                                                placeholder: `${I18n[lang].dateTo}`,
                                                                readOnly: true
                                                            }}
                                                            onChange={this.dateToTimeChange}
                                                            value={this.state.dateTo ? moment(this.state.dateTo).format('DD.MM.YYYY'): ''}
                                                        />
                                                        <div className="summary-btn__group">
                                                            <Button
                                                                color="primary"
                                                                type="button"
                                                                className="summary-btn btn-filter"
                                                                onClick={this.getFiltered}
                                                            >
                                                                {I18n[lang].filter}
                                                            </Button>
                                                            <Button
                                                                color="primary"
                                                                type="button"
                                                                className="summary-btn btn-clear"
                                                                onClick={this.clearFilters}
                                                            >
                                                                {I18n[lang].resetFilter}
                                                            </Button>
                                                            <Media
                                                                className={!this.state.isCsvDownload ?
                                                                    'summary-btn__spinner visually-hidden' : 'summary-btn__spinner'}
                                                                object
                                                                src={spinner}
                                                                alt="Generic placeholder image"
                                                            />
                                                            {/*<Button
                                                                color="secondary"
                                                                type="button"
                                                                className={this.state.isCsvDownload ?
                                                                    'summary-btn apk__download invisible' :
                                                                    'summary-btn apk__download visible'}
                                                                onClick={this.downloadCsv}
                                                            >
                                                                {I18n[lang].download}
                                                            </Button>*/}
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <div className="stat-table">
                                                <ReactTable
                                                    getProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            style: {
                                                                border: "none",
                                                                padding: "5px"
                                                            }
                                                        };
                                                    }}
                                                    getTheadProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            style: {
                                                                boxShadow: "none",
                                                                padding: "10px 0",
                                                                fontWeight: "600"
                                                            }
                                                        };
                                                    }}
                                                    getTheadThProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            style: {
                                                                borderRight: "none"
                                                            }
                                                        };
                                                    }}
                                                    getTdProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            style: {
                                                                borderRight: "none",
                                                                textAlign: "center"
                                                            }
                                                        };
                                                    }}
                                                    getTrProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            onClick: () => {
                                                                //const {dateFrom, dateTo} = this.state;
                                                                //this.props.changeLocation(`/dashboard/statistics/stores/${rowInfo.row._original.store.salesPointId}/?cid=${this.state.companyId}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
                                                            },
                                                            style: {
                                                                alignItems: "center"
                                                            }
                                                        };
                                                    }}
                                                    getNoDataProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            style: {
                                                                top: "100%"
                                                            }
                                                        };
                                                    }}
                                                    columns={columns}
                                                    PaginationComponent={Pagination}
                                                    nextText={">>"}
                                                    previousText={"<<"}
                                                    defaultPageSize={-1}
                                                    pageSize={tableData.length}
                                                    showPaginationBottom={this.props.pagination.totalPages > 1 ? true : false}
                                                    className="-highlight"
                                                    data={tableData}
                                                    filterable
                                                    manual
                                                    onPageChange={this.setCurrentPage}
                                                    page={this.state.currentPage}
                                                    pages={this.props.pagination.totalPages}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                            })()
                        }
                    </CardBody>
                </Card>
            </div>
        )
    }
};

const mapDispatchToProps = dispatch => {
    return {
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: (url) => dispatch(push(url)),
        fetchCompanies: (query) => dispatch(fetchCompanies(query)),
        fetchTraderStat: (query) => dispatch(fetchRedirectsStat(query)),
        downloadTotalCsvStat: query => dispatch(downloadTotalCsvStat(query))
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    companies: state.companiesReducer.companies,
    companyId: state.companiesReducer.companies.length > 1 ? null : state.companiesReducer.companies[0].id,
    authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    stat: state.promoTraderStat.redirectsStatisticItems,
    pagination: state.promoTraderStat.pagination,
    loading: state.promoTraderStat.loading,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoSummaryStat)



// WEBPACK FOOTER //
// ./src/components/Promo/PromoSummaryStat/PromoSummaryStat.js